<template>
    <div>
        <CFormCheck
            v-for="option in options"
            :id="id + '_' + option.value"
            :key="option.value"
            :value="option.value"
            type="radio"
            :label="option.label"
            :checked="option.value === value"
            @click="updateValue"
        />
    </div>
</template>

<script>
import { CFormCheck } from '@coreui/vue-pro'

export default {
    name: 'DRadioGroup',
    components: { CFormCheck },
    props: {
        options: {
            type: Object,
            default: () => {
                return {}
            }
        },
        id: {
            type: String,
            required: true
        },
        modelValue: {
            default: null,
            type: [String, Number]
        }
    },
    emits: ['update:modelValue'],
    data () {
        return {
            value: this.modelValue
        }
    },
    methods: {
        updateValue (event) {
            this.value = event.target.value
            this.$emit('update:modelValue', event.target.value)
        }
    }
}
</script>
